import React, { useState, useEffect, useCallback } from "react";
import { api, eur } from "../lib/api";
import { Search, Scale, TrendingDown, Award } from "lucide-react";

export default function PriceCompare() {
  const [q, setQ] = useState("");
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    const params = q ? { q } : {};
    api.get("/price-comparison", { params }).then((r) => setList(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [q]);

  useEffect(() => {
    const t = setTimeout(load, 300);
    return () => clearTimeout(t);
  }, [load]);

  return (
    <div className="space-y-5">
      <div>
        <h1 className="font-head text-3xl font-bold tracking-tight text-navy">Confronto Prezzi</h1>
        <p className="text-slate-500">Prezzo unitario dello stesso prodotto tra fornitori diversi (in EUR)</p>
      </div>

      <div className="relative">
        <Search className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" />
        <input data-testid="search-price" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca un prodotto (vuoto = solo prodotti da più fornitori)…" className="h-12 w-full rounded-lg border-2 border-slate-200 pl-11 pr-4 outline-none focus:border-gold" />
      </div>

      {loading ? (
        <div className="h-40 animate-pulse rounded-xl bg-slate-200" />
      ) : list.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-300 bg-white py-16 text-center">
          <Scale className="mx-auto mb-3 h-10 w-10 text-slate-300" />
          <p className="text-slate-400">{q ? "Nessun prodotto trovato." : "Nessun prodotto acquistato da più fornitori ancora. Registra fatture da fornitori diversi per confrontare i prezzi."}</p>
        </div>
      ) : (
        <div className="space-y-3">
          {list.map((p, idx) => (
            <div key={idx} data-testid={`price-row-${idx}`} className="rounded-xl border border-slate-200 bg-white p-4">
              <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
                <div className="font-head text-lg font-semibold text-navy">
                  {p.product} <span className="text-sm font-normal text-slate-400">/ {p.unit || "unità"}</span>
                </div>
                {p.saving_pct > 0 && (
                  <span className="flex items-center gap-1 rounded-full bg-emerald-100 px-3 py-1 text-xs font-bold text-emerald-700">
                    <TrendingDown className="h-3.5 w-3.5" /> Risparmio fino al {p.saving_pct}%
                  </span>
                )}
              </div>
              <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
                {p.offers.map((o, i) => {
                  const best = o.unit_price === p.min && p.offers.length > 1;
                  return (
                    <div key={i} className={`flex items-center justify-between rounded-lg border px-3 py-2 ${best ? "border-emerald-300 bg-emerald-50" : "border-slate-200 bg-white"}`}>
                      <div className="min-w-0">
                        <div className="flex items-center gap-1.5 truncate font-medium text-navy">
                          {best && <Award className="h-4 w-4 shrink-0 text-emerald-600" />}
                          {o.supplier}
                        </div>
                        <div className="tnum text-xs text-slate-400">{o.date}</div>
                      </div>
                      <div className={`tnum font-head text-lg font-bold ${best ? "text-emerald-700" : "text-navy"}`}>{eur(o.unit_price)}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
